import CartInfo from "./CartInfo";

export default CartInfo;
